import React from "react";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { at } from "lodash";
import { useField } from "formik";

const SelectField = (props) => {
  const {
    errorText,
    label,
    data,
    width,
    labelType,
    isDisabled,
    ...rest
  } = props;

  const [field, meta, helper] = useField(props);
  const { setValue } = helper;
  const { value } = field;
  const [touched, error] = at(meta, "touched", "error");
  const isError = touched && error && true;

  const onChange = (event) => {
    setValue(event.target.value);
  };
  return (
    <div>
      <InputLabel id={label}>{label}</InputLabel>
      <FormControl {...rest} error={isError}>
        <Select
          labelId={label}
          defaultValue={""}
          value={value || (value === 0 ? 0 : "")}
          sx={{
            width: width || "270px",
            '& .MuiInputBase-input ': {
              padding:'0',
            }
          }}
          onChange={onChange}
          disabled={isDisabled}
        >
          {data &&
            data?.map((item) => (
              <MenuItem
                key={item.code || item.id}
                value={item.code || item.id}
              >
                {item.code || item.name}
              </MenuItem>
            ))}
        </Select>
        {isError && <FormHelperText>{errorText}</FormHelperText>}
      </FormControl>
    </div>
  );
};
export default SelectField;
